import { i as k } from "../toString-3b91b335.mjs";
import { b as I } from "../_baseIteratee-4c4d0995.mjs";
import { i as g } from "../identity-6eafe87b.mjs";
import P from "./getMultiProductSubProductsTicketItems.mjs";
import "../isArray-0d9c7aaa.mjs";
import "../_getTag-4e44633b.mjs";
import "../_baseIsEqual-12d01a44.mjs";
function f(t, e, n) {
  for (var u = -1, m = t.length; ++u < m; ) {
    var o = t[u], s = e(o);
    if (s != null && (c === void 0 ? s === s && !k(s) : n(s, c)))
      var c = s, i = o;
  }
  return i;
}
function l(t, e) {
  return t < e;
}
function a(t, e) {
  return t && t.length ? f(t, I(e), l) : void 0;
}
function T(t) {
  return t && t.length ? f(t, g, l) : void 0;
}
function O(t) {
  const { items: e, ticketItems: n, modifications: u } = t, m = e.length > 0, o = u.length > 0;
  if (m) {
    const s = P(t), c = n.map((i) => {
      const { ticketId: p, status: b } = i, d = [...s[p].map(
        (h) => h.status
      )];
      o && d.push(b);
      const r = T(d);
      return r !== void 0 ? { ...i, status: r } : i;
    });
    return a(
      c,
      "status"
    );
  }
  return a(n, "status");
}
export {
  O as default
};
